import React, { PureComponent } from 'react';
import BonusHistory from '../bonus-orders-history';
import CustomError from './custom-errors';

//import testData from './testDataBonusCard';

class BonusCardError extends CustomError {
  constuctor() {
    this.name = 'BonusCardError';
  }
}

export default class BonusCardBlock extends PureComponent {
  state = {
    regionId: null,
    cards: null,
    isVirtualCard: false,
    percent: null,
    numberCard: null,
    cardImg: null,
    isLoading: true,
  };

  async componentDidMount() {
    const response = await this.getData();
    const userRest = response.data.user_rest;
    if (!userRest) {
      this.setState({
        isLoading: false,
      });
      return;
    }
    const cards = userRest.cards;
    if (cards.length) {
      this.setState({
        cards: response.data.user_rest.cards,
        percent: response.data.user_rest.cards[0].movie.percents,
        isVirtualCard: response.data.user_rest.cards[0].virtual,
        numberCard: response.data.user_rest.cards[0].number,
      });
    }
    this.setState({
      regionId: response.data.user_rest.region_id,
      cardImg: response.data.card_img,
      isLoading: false,
    });
  }

  getData = async () => {
    try {
      const route = '/local/php_interface/api/v2/user';
      const response = await fetch(route);
      const data = await response.json();
      // const data = await testData;
      if (data.status === 'success') return data;
    } catch (error) {
      throw new BonusCardError('No Data', 400);
    }
  };

  virtualCard = (percent, numberCard, regionId) => {
    return (
      <>
        <div className="card-progress">
          <div className="row">
            <div className="card-progress__preview">
              <div className="card-progress__final-body"></div>
              <div className="card">
                <img
                  className="card__pic"
                  src="/local/templates/comfortkino/static/img/virtual-card.png"
                  alt="Виртуальная карта"
                />
                <div className="card-block__img__card-number">{numberCard}</div>
                <div className="card-block__img__card-name">
                  ВИРТУАЛЬНАЯ КАРТА
                </div>
              </div>
            </div>
            <div className="card-block__persent card-progress__preview card-progress__preview--bonus-card">
              <div className="card-block__persent__title">
                <span className="card-block__persent__title__text">
                  Процент начисления
                </span>
                <div className="card-block__persent__title__qustion">
                  <span>?</span>
                  <div className="card-block-disc">
                    <div className="card-block-disc__text">
                      <a className="link" href="/about/bonus" target="_blank">
                        Подробнее о системе Кинобонус
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-block__persent__value">
                <span className="persent-value persent-value--card-virtual">
                  {percent * 100}%
                </span>
              </div>
              <div className="card-progress">
                  {regionId === 6 ? null : (<a className="btn btn--accent card-activate" href="#card-activate">
                      Привязать карту
                  </a>)}
                  <a className="btn btn--outline card-bonus" href="/about/bonus" target="_blank">
                      Подробнее
                  </a>
              </div>
            </div>
          </div>
        </div>
        <BonusHistory />
      </>
    );
  };

  noCard = () => {
    return (
      <>
        <div className="card-progress">
          <div className="row">
            <div className="card-progress__preview">
              <div className="card-info__action">
                <div className="card-info__action-body">
                  <h4 className="heading">VIP-карта не привязана :(</h4>
                  <div className="card-info__action-btn">
                    <a className="btn btn--accent" href="#card-activate">
                      Привязать карту
                    </a>
                    <a className="link btn-link" href="/about/bonus#how">
                      Как ее получить?
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-block__persent card-progress__preview card-progress__preview--bonus-card">
              <h3 className="heading">Что дает карта?</h3>
              <ul className="checklist checklist-nobonus">
                <li className="checklist__item">
                  Получать бонусами 10% от&nbsp;всех
                  ваших&nbsp;походов&nbsp;в&nbsp;кино
                </li>
                <li className="checklist__item">
                  Тратить бонусы на покупку билетов
                </li>
                <li className="checklist__item">
                  И еще много других приятных скидок
                </li>
              </ul>
              <a className="btn btn--outline card-no-bonus" href="/about/bonus">
                Подробнее
              </a>
            </div>
          </div>
        </div>
        <div className="page-section__block--bonus-history">
          <div className="page-section__title">
            <h2 className="heading heading--1" style={{ opacity: 0.4 }}>
              История начислений
            </h2>
          </div>
          <div className="order-wrap">
            <div className="timeline-notfull timeline-notfull--bonus-history">
              <img
                src="/local/templates/comfortkino/static/img/lock.svg"
                alt=""
              />
              <p className="timeline-notfull__descr timeline-notfull__descr--nobonus">
                История начислений бонусов станет доступна, после активации
                бонусной карты
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };

  bonusCard = (percent, cardImg) => {
    return (
      <>
        <div className="card-progress">
          <div className="row">
            <div className="card-progress__preview">
              <div className="card-progress__final-body"></div>
              <div className="card">
                <img className="card__pic" src={cardImg} alt="Бонусная карта" />
              </div>
            </div>
            <div className="card-block__persent card-progress__preview card-progress__preview--bonus-card">
              <div className="card-block__persent__title">
                <span className="card-block__persent__title__text">
                  Процент начисления
                </span>
                <div className="card-block__persent__title__qustion">
                  <span>?</span>
                  <div className="card-block-disc">
                    <div className="card-block-disc__text">
                      <a className="link" href="/about/bonus" target="_blank">
                        Подробнее о системе Кинобонус
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-block__persent__value">
                <span className="persent-value">{percent * 100}%</span>
              </div>
              <div className="card-progress">
                <a className="btn btn--outline card-bonus" href="/about/bonus" target="_blank">
                 Подробнее
                </a>
                <a className="btn-link link--accent card-bonus" href="/about/bonus#lost" target="_blank">
                  <span>Потеряли карту?</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <BonusHistory />
      </>
    );
  };

  bonusInApp = () => {
    return (
      <>
        <div
          className={`banner-mobileapp banner-mobileapp--red banner-mobileapp--card-block`}
        >
          <div className="banner-mobileapp__text">
            <h3 className="banner-mobileapp__title">С приложением удобно!</h3>
            <p className="banner-mobileapp__description">
              Установите приложение, накапливайте бонусы и оплачивайте ими
              билеты в кино!
            </p>
            <div className="banner-mobileapp__actions">
              <a
                href="https://vk.cc/a0TWtB"
                target="_blank"
                className="banner-mobileapp__actions__gplay"
              ></a>
              <a
                href="https://vk.cc/a0TW4q"
                target="_blank"
                className="banner-mobileapp__actions__appstore"
              ></a>
            </div>
          </div>
          <div className="banner-mobileapp__image"></div>
        </div>
        <div className="page-section__block--bonus-history">
          <div className="page-section__title">
            <h2 className="heading heading--1" style={{ opacity: 0.4 }}>
              История начислений
            </h2>
          </div>
          <div className="order-wrap">
            <div className="timeline-notfull timeline-notfull--bonus-history">
              <img
                src="/local/templates/comfortkino/static/img/lock.svg"
                alt=""
              />
              <p className="timeline-notfull__descr">
                История начисления бонусов доступна в приложении
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };

  render() {
    const {
      regionId,
      cards,
      percent,
      isVirtualCard,
      numberCard,
      cardImg,
      isLoading,
    } = this.state;

    if (isLoading) {
      return (
        <div className="bonus-history-is-loading-icon">
          <img
            src="/local/templates/comfortkino/static/img/pop-corn.gif"
            alt="Загрузка"
          />
        </div>
      );
    }

    if (regionId === 5) {
      return this.bonusInApp();
    }

    if (isVirtualCard) {
      return this.virtualCard(percent, numberCard, regionId);
    }

    if (cards && !isVirtualCard) {
      return this.bonusCard(percent, cardImg);
    }

    return this.noCard();
  }
}
